import {useCallback, useState} from "react";

const useInput = (initValue) => {
    const [value, setValue,] = useState(initValue);

    const onChangeValue = useCallback((callbackValue) => {
        setValue(callbackValue)
    }, [])

    const reset = () => {
        setValue(initValue)
    }


    return [value, onChangeValue,reset];
}


export default useInput;